import { render, staticRenderFns } from "./CampaignFinancials.vue?vue&type=template&id=87b76db6&scoped=true&"
import script from "./CampaignFinancials.vue?vue&type=script&lang=js&"
export * from "./CampaignFinancials.vue?vue&type=script&lang=js&"
import style0 from "./CampaignFinancials.vue?vue&type=style&index=0&id=87b76db6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b76db6",
  null
  
)

export default component.exports